import ContentLoader from 'react-content-loader';

export const TitleLoader: React.FC = () => (
  <ContentLoader width="100%" height="100%" viewBox="0 0 100 10">
    <path d="M100,2.5c0,-1.38 -1.12,-2.5 -2.5,-2.5l-95,0c-1.38,0 -2.5,1.12 -2.5,2.5l0,5c0,1.38 1.12,2.5 2.5,2.5l95,0c1.38,0 2.5,-1.12 2.5,-2.5l0,-5Z" />
  </ContentLoader>
);

export default TitleLoader;
